var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZhihu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1495029134689,
    className: "icon",
    style: {},
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 3889,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M733.472 343.33h-120.273c-2.933 0-5.867 2.933-5.867 5.867v322.675c0 2.933 2.933 5.867 5.867 5.867h11.735s8.799 32.27 8.799 38.134c0 0 35.201-26.401 55.735-38.134h41.069c2.933 0 5.867-2.933 5.867-5.867v-322.675c2.933-2.933 0-5.867-2.933-5.867z",
    fill: "#0f88eb",
    "p-id": 3890
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M510.535 41.185c-258.141 0-469.347 211.206-469.347 469.347s211.206 469.347 469.347 469.347 469.347-211.206 469.347-469.347-208.272-469.347-469.347-469.347zM528.133 528.133h-108.539c-2.933 38.134-8.799 58.671-14.666 76.269l23.468-20.532 61.601 76.269s23.468 26.401 5.867 85.068l-96.804-126.137c-8.799 38.134-38.134 132.003-90.935 149.603-52.803 17.601-64.533 2.933-64.533 2.933 58.671-49.868 96.804-102.67 117.338-187.737 5.867-17.601 8.799-35.201 11.735-55.735h-120.273c5.867-44 26.401-46.934 26.401-46.934h99.737c2.933-61.601 2.933-123.203 2.933-140.804h-52.803c-2.933 5.867-2.933 11.735-5.867 20.532-20.532 52.803-67.469 49.868-67.469 49.868 14.666-32.27 35.201-88.002 52.803-143.738 17.601-52.803 61.601-49.868 61.601-49.868-11.735 32.27-17.601 55.735-23.468 76.269h158.407s17.601 0 14.666 46.934h-90.935c0 58.671 0 105.602-2.933 140.804h93.869c11.735 14.666 8.799 46.934 8.799 46.934zM783.342 718.803c0 2.933-2.933 5.867-5.867 5.867h-82.135c-23.468 8.799-76.269 46.934-76.269 46.934 0-5.867-11.735-38.134-14.666-46.934h-32.27c-2.933 0-5.867-2.933-5.867-5.867v-410.676c0-2.933 2.933-5.867 5.867-5.867h202.405c2.933 0 5.867 2.933 5.867 5.867v410.676z",
    fill: "#0f88eb",
    "p-id": 3891
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZhihu);
export default __webpack_public_path__ + "static/media/zhihu.d3d714bc8fe7dd5e78d6fec4bd89be5d.svg";
export { ForwardRef as ReactComponent };